import React from 'react';
import './index.scss';
export const Checked = props => {
	return <i className="iconfont checked">&#xe65b;</i>;
};
